// src/components/store/sections/gallery/GalleryV5MasonrygridRoyalViolet.tsx
"use client";

import React from "react";
import DynamicGalleryVariant from "./DynamicGalleryVariant";

export default function GalleryV5MasonrygridRoyalViolet(props: any) {
  return (
    <DynamicGalleryVariant
      variantNumber={5}
      archKey="masonry_grid"
      archLabel="Dynamic Masonry"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
